// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__KmHK7","footer":"styles_footer__3ngLc"};